module.exports = __webpack_public_path__ + "img/Previeweyezen-start_livre.4357100e.png";